import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FaArrowUp } from 'react-icons/fa';
import Wrapper from '../Wrapper';
import { getClassModifiers } from '../../utils';

const BackToTop = ({ type, showAfterPixels, ...otherProps }) => {
  const [goToTop, setGoToTop] = useState(false);
  const modifiers = getClassModifiers(type, otherProps);

  useEffect(
    () => {
      const handleOnScroll = () => setGoToTop(window.scrollY >= showAfterPixels);
      document.addEventListener('scroll', handleOnScroll);
      return () => document.removeEventListener('scroll', handleOnScroll);
    },
    [showAfterPixels]
  );

  const handleBackToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    setGoToTop(false);
  };

  return (
    <>
      {goToTop && (
        <Wrapper className={type} modifiers={modifiers} onClick={handleBackToTop}>
          <i>
            <FaArrowUp />
          </i>
        </Wrapper>
      )}
    </>
  );
};

BackToTop.propTypes = {
  type: PropTypes.string,
  showAfterPixels: PropTypes.number
};

BackToTop.defaultProps = {
  type: 'backtotop',
  showAfterPixels: 200
};

export default BackToTop;
